import type { ComponentProps, PropsWithChildren } from 'react'
import { ScrollView, Platform, KeyboardAvoidingView, StyleSheet } from 'react-native'
import { gap, maxWidth, useMainWrapperPadding } from '@/src/common/wrappers/MainWrapper'
import { NavigationSection } from '../components/NavigationSection'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useIsTabBarPositionedTop } from '@/src/common/components/TopTabBar'
import { mesaColorNames } from '@/src/common/theme'

export function MainChildWrapper({
  children,
  title,
  style,
}: PropsWithChildren &
  Pick<ComponentProps<typeof SafeAreaView>, 'style'> &
  Pick<ComponentProps<typeof NavigationSection>, 'title'>) {
  const isTabBarPositionedTop = useIsTabBarPositionedTop()
  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      style={{ flex: 1 }}
    >
      <SafeAreaView style={[styles.screenStyles, style]} edges={['top', 'left', 'right']}>
        <NavigationSection
          title={title}
          titleStyles={[styles.sectionTitle, isTabBarPositionedTop && { marginTop: gap }]}
          titleContainerStyles={
            !isTabBarPositionedTop && Platform.OS === 'web' && { marginTop: 24 }
          }
          headerContainerStyles={{ height: 'auto', paddingHorizontal: 24 }}
        />
        <ScrollView
          style={{ flex: 1 }}
          keyboardShouldPersistTaps="always"
          contentContainerStyle={{
            marginHorizontal: 'auto',
            padding: useMainWrapperPadding(),
            maxWidth,
          }}
        >
          {children}
        </ScrollView>
      </SafeAreaView>
    </KeyboardAvoidingView>
  )
}

const styles = StyleSheet.create({
  screenStyles: {
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    paddingBottom: 0,
    flex: 1,
  },
  sectionTitle: {
    color: mesaColorNames['Greyscale/900 #152438'],
  },
})
